'use client'
import { Popover } from 'antd'
import styles from './styled.module.scss'
import { Authentication } from 'core/components/Authenticate'
import { useLocale } from 'core/components/Locale'
import cls from 'classnames'
import { useHCRouter } from '@/components/HCNextLink'
import Button from '@/components/Button'
import React, { useState } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useResponsiveDevice } from '@/hooks/useResponsiveDevice'
import UserNav from './SideNav/UserNav'
import Overview from './UserPanel/Overview'

const User = () => {
  const t = useLocale()
  const router = useHCRouter()
  const queryClient = useQueryClient()
  const responsiveDevice = useResponsiveDevice()

  const userList = [
    {
      key: 'overView',
      title: '账户总览',
      link: '/user/overView',
      locale: 'contract_account_009',
    },
    {
      key: 'personSetting',
      title: '账户安全',
      link: '/user/personSetting',
      locale: 'contract_account_010',
    },
    {
      key: 'home',
      title: '福利中心',
      link: '/benefitsCenter/home',
      locale: 'benefits_center_001',
      suffix: 'hot',
    },
    {
      key: 'paymentSettings',
      title: 'C2C设置',
      link: '/c2c/paymentSettings',
      locale: 'otcAdvertise_222',
    },
    {
      key: 'ic',
      title: '好友邀请',
      link: '/user/ic',
      locale: 'header_050',
    },
    {
      key: 'apiSetting',
      title: 'API管理',
      link: '/user/apiSetting',
      locale: 'header_051',
    },
    {
      key: 'exchange',
      title: '合约模拟交易',
      link: '/simulation/exchange',
      locale: 'swaps_silumation_006',
    },
  ]

  const [isOpen, setIsOpen] = useState(false)

  const renderContent = (loginData, logout) => {
    const handleNavigation = (item: any) => () => {
      if (!loginData && item.meta?.auth) {
        router.push(`login`)
        return
      }
      router.push(item.link)
    }

    const handleLogout = () => {
      queryClient.clear()
      logout()
    }

    return (
      <div className={styles['user']}>
        <Overview />

        <div className={styles.walletFloor} style={{ marginTop: '16px' }}>
          <div className={styles.List}>
            {userList.map((item, index) => (
              <div key={index} className={styles.listItem} style={{ width: '284px' }} onClick={handleNavigation(item)}>
                <div className={cls([styles.leftIconUser, styles[item.key]])}></div>
                <div>{t(item.locale)}</div>
                <div className={cls(item?.suffix ? styles[item.suffix] : '')}></div>
              </div>
            ))}
          </div>
          <Button type="secondary" onClick={handleLogout}>
            <span className="f14 font-normal">{t('header_055')}</span>
          </Button>
        </div>
      </div>
    )
  }

  const [isNavOpen, setIsNavOpen] = useState(false)

  return (
    <Authentication
      allow={({ loginData, logout }) => {
        return (
          <div className={styles.container}>
            <Popover
              trigger={[responsiveDevice === 'pc' ? 'hover' : 'click']}
              content={renderContent(loginData, logout)}
              getPopupContainer={(node) => node.parentNode as HTMLElement}
              overlayInnerStyle={{ width: 332, height: 612, padding: '28px 24px' }}
              overlayClassName={cls(styles.popoverContent)}
              open={isOpen}
              onOpenChange={(value) => {
                if (responsiveDevice === 'pc') {
                  setIsOpen(value)
                } else {
                  setIsNavOpen(true)
                }
              }}
            >
              {loginData?.photo ? (
                // eslint-disable-next-line @next/next/no-img-element
                <div className={cls([styles.userIcon, 'bgc4'])}>
                  <img src={loginData?.photo} alt="" />
                </div>
              ) : (
                <i className={styles.defaultUserIcon}></i>
              )}
            </Popover>

            <UserNav isOpen={isNavOpen} onClose={() => setIsNavOpen(false)} />
          </div>
        )
      }}
    />
  )
}

export default User
